import Vue from 'vue'
import Router from 'vue-router'
import goTo from 'vuetify/lib/components/Vuetify/goTo'
import store from '@/store'
import wx from 'weixin-js-sdk';
import request from '@/common/utils/request'

Vue.use(Router)

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouter = [
    {
        path: '/',
        name: 'base',
        component: () => import('@/views/layout/index'),
        redirect: {name: 'intro'},
        children: [
            {
                path: 'challenge',
                name: 'challenge',
                meta: {title: '挑战与课程', icon: 'terrain'},
                component: () => import('@/views/mission/base'),
                redirect: {name: 'select'},
                children: [
                    {
                        path: 'select',
                        name: 'select',
                        component: () => import('@/views/mission/select'),
                        meta: {title: '挑战与课程', icon: '', loading: true}
                    },
                    {
                        path: ':cid/mission',
                        name: 'missionList',
                        component: () => import('@/views/mission/list'),
                        meta: {title: '挑战列表', icon: 'subject', loading: true}
                    },
                    {
                        path: ':cid/mission/:mid',
                        name: 'missionDetail',
                        component: () => import('@/views/mission/detail'),
                        meta: {title: '挑战详情', icon: 'subject', loading: true}
                    },
                ],
            },
            {
                path: 'rank',
                name: 'rank',
                component: () => import('@/views/rank/index'),
                meta: {title: '排行榜', icon: 'show_chart', loading: true}
            },
            {
                path: 'intro',
                component: () => import('@/views/intro/index'),
                name: 'intro',
                meta: {title: '介绍', icon: 'chat', loading: true},
            },
            {
                path: 'my',
                component: () => import('@/views/my/index'),
                name: 'my',
                meta: {title: '我的', icon: 'face', loading: true},
            },
            {
                path: 'points',
                component: () => import('@/views/points/index'),
                name: 'pointHistory',
                hidden: true,
                meta: {title: '积分记录', icon: 'face', loading: true},
            },
            {
                path: 'bounty',
                component: () => import('@/views/bounty/index'),
                name: 'bountyHistory',
                hidden: true,
                meta: {title: '奖励金记录', icon: 'face', loading: true},
            },
            {
                path: 'faq',
                component: () => import('@/views/faq/index'),
                name: 'faq',
                meta: {title: 'FAQ 常见问答', icon: 'forum', loading: true},
            },
            {
                path: 'success-stories',
                component: () => import('@/views/story/index'),
                name: 'story',
                meta: {title: '成长分享', icon: 'group_add'},
            },
            {
                path: 'product',
                name: 'productBase',
                component: () => import('@/views/product/base'),
                redirect: {name: 'productList'},
                meta: {title: '知识商城', icon: 'school', loading: true},
                children: [
                    {
                        path: 'list',
                        name: 'productList',
                        component: () => import('@/views/product/list'),
                        meta: {title: '', icon: 'show_chart', loading: true, disableFooter: true},
                        hidden: true
                    },
                ],
            },
            {
                path: 'product/:pid',
                name: 'productDetail',
                component: () => import('@/views/product/detail'),
                meta: {title: '', icon: 'show_chart', loading: true},
                hidden: true
            },
            {
                path: 'purchased',
                name: 'purchased',
                component: () => import('@/views/product/purchased'),
                meta: {title: '已解锁', icon: 'lock_open', loading: true},
            },
        ]
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/loggingIn/index'),
        hidden: true
    },
    {
        path: '/invite/:i/:m?',
        component: () => import('@/views/invite/index'),
        hidden: true
    },
    {
        path: '/404',
        component: () => import('@/views/errorPage/404'),
        hidden: true
    },
    {path: '*', redirect: '/404', hidden: true}
]


const router = new Router({
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0
        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }
        return goTo(scrollTo)
    },
    mode: 'history',
    routes: constantRouter
})

router.afterEach((to, from) => {
    request.get(
        `/api/wechat/sdk/`,
        {
            params: {
                url: window.entryUrl || encodeURIComponent(request.defaults.baseURL + to.fullPath),
                page: to.name
            }
        }).then(config => {
        wx.config({
            debug: false,
            appId: config.appId,
            timestamp: config.timestamp,
            nonceStr: config.nonceStr,
            signature: config.signature,
            jsApiList: config.actions
        });
        wx.error(function (err) {
            console.error(err);
        })
        wx.ready(() => {
            window.wx = wx
        })
    }).catch(e => {
        console.error(e);
    })
})

router.beforeEach((to, from, next) => {
    if (to.meta.loading) {
        store.dispatch('ShowLoading')
    }
    if (window.__wxjs_is_wkwebview) {  // IOS
        if (!window.entryUrl) {
            window.entryUrl = encodeURIComponent(location.href.split('#')[0])
        }
    }
    next()
})

export default router


